export default __webpack_public_path__ + "static/media/video-pink-icon.b083859a.svg";